<template>
    <div class="project-message" :class="[{'middle': middle}]">
        <div class="text" :class="[{'login-msg': loginMsg}]">{{text}}</div>
    </div>
</template>

<script>
export default {
    name: "message",
    props: {
        text: "",
        middle: Boolean,
        loginMsg: Boolean
    },
    data() {
        return {
            isShow: false,
            messageTimeout: null
        }
    },
    mounted() {
        console.log(this.middle)
    }
}
</script>

<style lang="scss" scoped>
.project-message {
    width: 302px;
    position: fixed;
    bottom: 45%;
    left: 36.5px;
    color: white;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    z-index: 999;

    &.middle {
        bottom: 50%;
    }

    .text {
        margin: 0 auto;
        width: fit-content;
        border-radius: 29.5px;
        padding: 12px 25px;
        box-sizing: border-box;
        background: rgba(0,0,0,0.8);

        &.login-msg {
            border-radius: 13px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/api/message.vue